import React from "react"
import Button from "../../../../../_components/Button"
import { FormControl } from "react-bootstrap"
import styled from "styled-components"
import Text from "../../../../../_components/Text"
import LoadingInput from "../../../../../_components/LoadingInput"
import Modal from "../../../../../_components/Modal"
import CurrencyInput from "react-currency-input"
import { createIPI, updateIPI } from "../../../../../api/products/taxes"
import { showSnackBar } from "../../../../../utils"
import * as colors from "../../../../../assets/_base/colors"

const TextButton = styled.p`
    margin-top: 2px;
    cursor: pointer;
    padding: 5px;
    color: ${colors.darkBlue};
    font-weight: bold;
`
/*
    Não tributados: 01, 02, 03, 04, 51, 52, 53, 54, 55
    Se o CST de IPI for de Imunidade (“04” de Entrada ou “54” de Saída), o Código de Enquadramento deve ser de "001” a “099”;
    Se o CST de IPI for de Suspensão (“05” de Entrada ou “55” de Saída), o Código de Enquadramento deve ser de "101” a “199”;
    Se o CST de IPI for de Isenção (“02” de Entrada ou “52” de Saída), o Código de Enquadramento deve ser de "301” a “399”;
    Se o CST de IPI for de Redução (“49” de Entrada ou “99” de Saída), o Código de Enquadramento deve ser de "601” a “608”;
    E para a tributação normal de IPI ou para “Outros”, o Código de Enquadramento deve ser de "999”.
*/

export const CSTData = [
    { code: "99", description: "Outras saídas" },
    { code: "00", description: "Entrada com recuperação de crédito" },
    { code: "01", description: "Entrada tributada com alíquota zero" },
    { code: "02", description: "Entrada isenta" },
    { code: "03", description: "Entrada não-tributada" },
    { code: "04", description: "Entrada imune" },
    { code: "05", description: "Entrada com suspensão" },
    { code: "49", description: "Outras entradas" },
    { code: "50", description: "Saída tributada" },
    { code: "51", description: "Saída tributada com alíquota zero" },
    { code: "52", description: "Saída isenta" },
    { code: "53", description: "Saída não- tributada" },
    { code: "54", description: "Saída imune" },
    { code: "55", description: "Saída com suspensão" },
]

export default props => {
    const [loading, setLoading] = React.useState(false)
    const [isValid, setIsValid] = React.useState(true)
    const [show, setShow] = React.useState(false)
    const [frameCodeHelper, setFrameCodeHelper] = React.useState("")
    const [data, setData] = React.useState({ cst: "99", c_enq: "999", "calculo": 0, p_ipi: 0 })

    function closeModal() {
        if (loading) {
            return
        }
        setShow(false)
        setData({ cst: "99", c_enq: "999", "calculo": 0 })
        if (props.onClose) {
            props.onClose()
        }
    }
    function onChange(e) {
        const { name: key, value } = e.target
        setData({
            ...data,
            [key]: value
        })
    }
    function onSave() {
        let request = createIPI
        if (props.show) {
            if (props.show === true) {
                request = updateIPI
            }
        }
        if (!data.name) {
            showSnackBar("Informe o nome!")
            setLoading(false)
            try { document.querySelector('[name="name"]').focus() } catch (error) { }
            return
        }
        if (!data.c_enq) {
            showSnackBar("Informe o Código Enquadramento do IPI!")
            try { document.querySelector('[name="c_enq"]').focus() } catch (error) { }
            setLoading(false)
            return
        }
        setLoading(true)
        request(data)
            .then(ipi => {
                setShow(false)
                if (props.onSave) {
                    props.onSave(ipi)
                }
                showSnackBar("IPI salvo com sucesso!", "info")
            })
            .catch(error => {
                showSnackBar("Erro ao salvar o IPI!")
                setLoading(false)
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false)
                    setData({ cst: "99", c_enq: "999", "calculo": 0 })
                }, 5000)
            })
    }
    function open() {
        if (props.show === true) {
            setData({ ...props.ipi })
        }
    }

    React.useEffect(open, [props.show])

    return <React.Fragment >
        {
            props.textButton ? <TextButton onClick={() => setShow(true)}>
                Criar Modelo IPI
            </TextButton>
                : <Button onClick={() => setShow(true)}>
                    Criar Modelo IPI
                </Button>
        }

        <Modal
            show={props.show || show}
            title="Criar Modelo IPI"
            onHide={closeModal}>
            <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Descrição IPI
                                </Text>
                            </div>
                            <LoadingInput
                                name="name"
                                value={data.name}
                                onChange={onChange}
                                loading={loading}
                                maxLength={100} />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    CST IPI
                                </Text>
                                <FormControl
                                    name="cst"
                                    defaultValue={data.cst}
                                    onChange={onChange}
                                    disabled={loading}
                                    as="select">
                                    <option value="" selected disabled>
                                        Selecione o CST
                                    </option>
                                    {
                                        CSTData.map(((cst, idx) => {
                                            return <option
                                                key={`cst-data-select-${cst.code}-${idx}`}
                                                selected={cst.code === data.cst}
                                                value={cst.code} >
                                                {cst.code} - {cst.description}
                                            </option>
                                        }))
                                    }
                                </FormControl>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Código Enquadramento IPI
                                </Text>
                            </div>
                            <LoadingInput
                                name="c_enq"
                                value={data.c_enq}
                                onChange={onChange}
                                loading={loading}
                                maxLength={4} />
                            <Text>
                                {frameCodeHelper}
                            </Text>
                        </div>
                    </div>
                    <div className="col-md-4 col-xs-12">
                        <div className="form-group">
                            <div className="form-label">
                                <Text>
                                    Alíquota IPI
                                </Text>
                            </div>
                            <CurrencyInput
                                className="form-control"
                                name="p_ipi"
                                value={data.p_ipi}
                                suffix="% "
                                onChange={(a, b, c) => onChange({ target: { name: "p_ipi", value: b } })}
                                disabled={loading}
                                maxLength={100} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="d-flex justify-content-end">
                            <Button
                                disabled={loading || !isValid}
                                onClick={onSave}>
                                Salvar IPI
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/IPI/Template/index.jsx